import styled, { css } from 'styled-components';
import { Button, ButtonSize, ButtonAppearance } from '@bechtel/gds';
import { CrewChangeRequestStatusCode } from '@bechtel/types';

interface CrewChangeItemCardStyledProps {
  status: CrewChangeRequestStatusCode;
}

export const CrewChangeItemCardStyled = styled.div<CrewChangeItemCardStyledProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['300']};
  width: 100%;
`;

export const CrewChangeItemContainerStyled = styled.div`
  display: grid;
  margin: 12px;
  grid-template-rows: 20px 12px 12px 32px 8px 32px 12px auto;
`;

export const ActionButtonStyled = styled(Button).attrs({
  size: ButtonSize.MEDIUM,
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[300]};
    color: ${theme.colors.blue[900]};

    &:hover {
      background-color: ${theme.colors.blue[200]};
    }

    &:active {
      background-color: ${theme.colors.blue[400]};
    }
  `}
`;

export const CancelActionButtonStyled = styled(Button).attrs({
  size: ButtonSize.MEDIUM,
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.yellow[300]};
    color: ${theme.colors.grey[1000]};

    &:hover {
      background-color: ${theme.colors.yellow[300]};
    }

    &:active {
      background-color: ${theme.colors.yellow[300]};
    }
  `}
`;

export const ClosedActionButtonStyled = styled(Button).attrs({
  size: ButtonSize.MEDIUM,
  appearance: ButtonAppearance.TERTIARY,
})`
  pointer-events: none;
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    color: ${theme.colors.black[1000]};
  `}
`;
